import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { AppLayout } from "../../layout";

interface HelpCentersLoadingStateProps {
  breadcrumbs: Array<{ title: string; href?: string; isCurrentPage?: boolean }>;
}

export const HelpCentersLoadingState: React.FC<HelpCentersLoadingStateProps> = ({
  breadcrumbs,
}) => {
  return (
    <AppLayout showSidebar={true} breadcrumbs={breadcrumbs}>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-10 w-32" />
        </div>
        <div className="space-y-2">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="flex items-center space-x-4 p-4 border rounded-lg"
            >
              <Skeleton className="h-4 w-1/4" />
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-8 w-24" />
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
};

